import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ResponseBase } from '../models/response-base';
import { DadoBancarioCedente } from '../models/dado-bancario-cedente';
import { HttpClient } from '@angular/common/http';
import { DadoBancarioCedenteCadastro } from '../models/dado-bancario-cedente-cadastro';
import { Banco } from '../models/banco';
import { LocalStoreKeys } from '../shared/helpers/localstorage/local-store';

@Injectable({
  providedIn: 'root'
})
export class DadoBancarioService {
  API: string = environment.API + 'Portal/dadosbancarios';
  APIbancos: string = environment.API + 'Portal/bancos';

  constructor(private http: HttpClient) { }

  getAll(cedenteGuid: string, gestorGuid: string): Observable<ResponseBase<DadoBancarioCedente[]>> {
    return this.http.get<ResponseBase<DadoBancarioCedente[]>>(`${this.API}/cedentes/${cedenteGuid}/gestores/${gestorGuid}`);
  }

  getByGuid(dadoBancarioGuid: string, cedenteGuid: string, gestorGuid: string): Observable<ResponseBase<DadoBancarioCedente>> {
    return this.http.get<ResponseBase<DadoBancarioCedente>>(`${this.API}/${dadoBancarioGuid}/cedentes/${cedenteGuid}/gestores/${gestorGuid}`);
  }

  add(dadoBancarioCedenteCadastro: DadoBancarioCedenteCadastro, cedenteGuid: string, gestorGuid: string): Observable<ResponseBase<DadoBancarioCedente>> {
    return this.http.post<ResponseBase<DadoBancarioCedente>>(`${this.API}/cedentes/${cedenteGuid}/gestores/${gestorGuid}`, dadoBancarioCedenteCadastro);
  }

  update(dadoBancarioGuid: string, dadoBancarioCedenteCadastro: DadoBancarioCedenteCadastro, cedenteGuid: string, gestorGuid: string):
    Observable<ResponseBase<DadoBancarioCedente>> {
    return this.http.put<ResponseBase<DadoBancarioCedente>>
      (`${this.API}/${dadoBancarioGuid}/cedentes/${cedenteGuid}/gestores/${gestorGuid}`, dadoBancarioCedenteCadastro);
  }

  delete(dadoBancarioGuid: string, cedenteGuid: string, gestorGuid: string): Observable<ResponseBase<DadoBancarioCedente>> {
    return this.http.delete<ResponseBase<DadoBancarioCedente>>(`${this.API}/${dadoBancarioGuid}/cedentes/${cedenteGuid}/gestores/${gestorGuid}`);
  }

  getAllBancos(): Observable<ResponseBase<Banco[]>> {
    return this.http.get<ResponseBase<Banco[]>>(this.APIbancos);
  }

  setPossuiConta(flag: boolean) {
    localStorage.setItem(LocalStoreKeys.possuiConta, flag.toString());
  }

  getPossuiConta() {
    return localStorage.getItem(LocalStoreKeys.possuiConta) === 'true';
  }
}
